import { Layout } from 'types/careguide-page'

const PageLayoutContentOnly: Layout = ({ children }) => <>{children}</>

export default PageLayoutContentOnly
